import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { CategoryService } from 'src/app/services/category.service';
import { CommonService } from 'src/app/services/common.service';
import { MembershipService } from 'src/app/services/membership.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-edit-academymembership',
  templateUrl: './edit-academymembership.component.html',
  styleUrls: ['./edit-academymembership.component.scss'],
  providers: [MessageService]
})

export class EditAcademymembershipComponent implements OnInit, OnDestroy {

  private destroy$ = new Subject<void>();
  pagetitle: string;
  academyMembershipForm: FormGroup;
  submitted: boolean = false;
  currencyList: any;
  id: string;
  sportTypeList: any;
  membershipTypes: { name: string; value: string; }[];

  constructor(private formBuilder: FormBuilder, private router: Router, private membershipService: MembershipService, private activatedRoute: ActivatedRoute,
    private messageService: MessageService, private commonService: CommonService, private categoryService: CategoryService) { }

  ngOnInit(): void {
    this.pagetitle = 'Edit Membership';
    this.id = this.activatedRoute.snapshot.paramMap.get('id');
    this.membershipTypes = [
      { name:'Academy', value: 'academy'},
      { name: 'User', value: 'user'}
    ];

    this.academyMembershipForm = this.formBuilder.group({
      membershipType: [null, [Validators.required]],
      sport: [null, [Validators.required]],
      planName: ['', [Validators.required]],
      currency: [{name: "INR", currency_symbol: "₹"}, [Validators.required]],
      price: [null, [Validators.required]],
      benefit: this.formBuilder.array([]),
      duration: [null, [Validators.required]],
      discountPrice: [null,[Validators.required]],
      status: [true]
    })

    this.getSportTypeList();
    this.getCurrencyList();
    setTimeout(()=>{
      this.getMembership(this.id);
    },500);
  }
  
  getSportTypeList() {
    const query = `?filterByDisable=false&getSubcategory=true&filterByParentCategory=Sport`;
    this.categoryService.getCategoryList(query).pipe(takeUntil(this.destroy$)).subscribe((data:any) => {
      this.sportTypeList = data.data.items;
    }, err => {
      this.messageService.add({ key: 'toastmsg', severity: 'error', summary: "Error", detail: err.error.message, life: 6000 });
    })
  }

  getMembership(id:string) {
    this.membershipService.getMembershipById(id).pipe(takeUntil(this.destroy$)).subscribe((data:any) => {
      this.academyMembershipForm.patchValue({
        membershipType: data?.membershipType,
        sport: data?.sport,
        planName: data?.planName,
        currency: this.currencyList.find(ele => ele.name === data?.currency),
        price: data?.price,
        discountPrice: data?.discountPrice,
        duration: data?.duration,
        status: data?.status,
      })

      this.onSelectAcademyMembershipType({ value: data?.membershipType });

      data?.benefit.forEach((ele,index) => {
        this.addBenefit();
        this.academyMembershipForm.controls['benefit']['controls'][index]['controls']['key'].setValue(ele.key);
        this.academyMembershipForm.controls['benefit']['controls'][index]['controls']['value'].setValue(ele.value);
      })
    })
  }

  getCurrencyList() {
    this.commonService.getCurrencyList().pipe(takeUntil(this.destroy$)).subscribe((data) => {
      this.currencyList = data.data.items;
    })
  }

  get benefitsFormArray(): FormArray {
    return this.academyMembershipForm.get('benefit') as FormArray;
  }

  benefitFormGroup() {
    return this.formBuilder.group({
      key: ['', [Validators.required]],
      value: ['', [Validators.required]]
    })
  }

  addBenefit() {
    this.benefitsFormArray.push(this.benefitFormGroup());
  }

  removeBenefit(index:number) {
    this.benefitsFormArray.removeAt(index);
  }

  get f() {
    return this.academyMembershipForm.controls;
  }

  g(i:number) { 
    return this.academyMembershipForm.controls['benefit']['controls'][i]['controls'];
  }

  onSelectAcademyMembershipType(event) {
    this.academyMembershipForm.get('sport').setValidators((event.value === 'academy') ? [Validators.required] : null);
    this.academyMembershipForm.get('sport').updateValueAndValidity();
  }

  onSubmit() {
    this.submitted = true;
    let academyMembershipFormData = JSON.parse(JSON.stringify(this.academyMembershipForm.value));

    if (this.academyMembershipForm.invalid) {
      return;
    }

    academyMembershipFormData['currency'] = this.academyMembershipForm.value['currency']['name'];
    academyMembershipFormData['currencySymbols'] = this.academyMembershipForm.value['currency']['currency_symbol'];

    academyMembershipFormData = JSON.stringify(academyMembershipFormData, null, 4);
    this.membershipService.updateMembership(academyMembershipFormData, this.id).pipe(takeUntil(this.destroy$)).subscribe((data) => {
      this.messageService.add({ key: 'toastmsg', severity: 'success', summary: 'Successful', detail: 'Membership Updated', life: 6000 });
      setTimeout(() => {
        this.router.navigate(['/manage/membership']);
      }, 2000);
    }, (error) => {
      this.messageService.add({ key: 'toastmsg', severity: 'error', summary: "Error", detail: error.error.message, life: 6000 });
    })
  }

  backLink() {
    this.router.navigate(['/manage/membership']);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}

